import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { RegionalStoreStructure } from '../model/RegionalStoreStructure';
import { CatalogDet } from '../model/CatalogDet';


@Injectable()
export class RegionalStoreStructureFacade {
  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetRegionalStoreStructureByCatDetRegionStoreTypeId(typeId: Number): Observable<RequestResponse<RegionalStoreStructure[]>> {
    return this._httpClient.get<RequestResponse<RegionalStoreStructure[]>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionalStoreStructureGetByCatDetRegionStoreTypeId?CatDetRegionStoreTypeId=' + typeId);
  } 

  GetRegionalStoreStructureByCatDetRegionStoreTypeIdOrganization(typeId: Number, organizationId: string): Observable<RequestResponse<RegionalStoreStructure[]>> {
    return this._httpClient.get<RequestResponse<RegionalStoreStructure[]>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionalStoreStructureGetByCatDetRegionStoreTypeIdOrganizationId?CatDetRegionStoreTypeId=' + typeId + '&OrganizationId=' + organizationId);
  }

  GetRegionalStoreStructureDetGetByRegStoreStrId(regStoreStrId: number, catId: number): Observable<RequestResponse<any>> {
    return this._httpClient.get<RequestResponse<any>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionalStoreStructureDetGetByRegStoreStrId?regStoreStrId='
    + regStoreStrId + '&catDetRegionStoreTypeId=' + catId );
  }

  GetRegionalStoreStructureDetGetByRegStoreStrIdOrganizationId(regStoreStrId: number, catId: number, organizationId:string): Observable<RequestResponse<any>> {
    return this._httpClient.get<RequestResponse<any>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionalStoreStructureDetGetByRegStoreStrIdOrganizationId?regStoreStrId='
    + regStoreStrId + '&catDetRegionStoreTypeId=' + catId + '&organizations=' + organizationId);
  }

  GetRegionalStoreStructure(catDetTaskTypeId: number): Observable<RequestResponse<CatalogDet[]>> {
    return this._httpClient.get<RequestResponse<CatalogDet[]>>(this._urlBase + 'api/CatalogDet/Web?catId=' + catDetTaskTypeId);
  }

  GetRegionalStoreStructureStoreAvailableByCatDetRegionStoreTypeId(catId: number): Observable<RequestResponse<any>> {
    return this._httpClient.get<RequestResponse<any>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionalStoreStructureStoreAvailable?catDetRegionStoreTypeId=' + catId );
  }

  GetRegionalStoreStructureStoreAvailableByCatDetRegionStoreTypeIdOrganizations(catId: number, organizationId: string[]): Observable<RequestResponse<any>> {
    let organizations = organizationId.toString();
    return this._httpClient.get<RequestResponse<any>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionalStoreStructureStoreAvailableOrganization?catDetRegionStoreTypeId=' + catId + '&organizations=' + organizations);
  }

  GetRegionsRegionalStoreStructureStore(catDetTaskTypeId: number): Observable<RequestResponse<any>> {
    return this._httpClient.get<RequestResponse<any>>
    (this._urlBase + 'api/RegionalStoreStructure/RegionsRegionalStoreStructureStore?catDetRegionStoreTypeId=' + catDetTaskTypeId );
  }

  PostRegionalStoreStructure(parameters: RegionalStoreStructure): Observable<any> {
    const body = JSON.stringify(parameters);
    return this._httpClient.post(this._urlBase + 'api/RegionalStoreStructure/', body, {
        headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }

  DeleteRegionalStoreStructure(regStoreStrId: number): Observable<RequestResponse<boolean>> {
      return this._httpClient.delete<RequestResponse<boolean>>(this._urlBase + 'api/RegionalStoreStructure/' + regStoreStrId);
  }

  PutRegionalStoreStructure(parameters:  any): Observable<any> {
    const body = JSON.stringify(parameters);
    return this._httpClient.put(this._urlBase + 'api/RegionalStoreStructure/', body, {
        headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }

}
